import { Icon } from "@fortawesome/fontawesome-svg-core";
import {
  faCog,
  faStore,
  faLifeRing,
  faHexagonImage,
  faStar,
} from "@fortawesome/pro-light-svg-icons";
import { useGetSidebarCountProduct } from "~/api/sidebarCounts/queries";
import { paths } from "~/router/paths";
import { INavItem } from "~/types/routing";

export const navItems: Array<INavItem> = [
  {
    namePath: "nav.import_reviews",
    path: paths.app.home,
    icon: faStore as Icon,
  },
  {
    namePath: "nav.manage_reviews",
    path: paths.reviews.manage,
    icon: faStar as Icon,
    getCountQuery: useGetSidebarCountProduct,
  },
  {
    namePath: "nav.reviews_widget",
    path: paths.reviews.widget,
    icon: faHexagonImage as Icon,
  },
  {
    namePath: "settings.title",
    path: paths.settings.index,
    icon: faCog as Icon,
  },
  {
    namePath: "nav.help_center",
    path: "https://aquatic-knife-cdd.notion.site/ReviewsPro-09e58b4d2e5e4ef9ac16013932fa78de?pvs=4",
    openInNewTab: true,
    icon: faLifeRing as Icon,
    // Uncomment this to show help center as a modal
    showHelpCenterModal: true,
  },
];
